import React, { forwardRef } from 'react';
import { Search, X } from 'lucide-react';

/**
 * The search box: the scope chip (icon + translated label; a button labelled
 * "Remove filter Boards") and the combobox input (§2.7).
 */
const PaletteInput = forwardRef(function PaletteInput(
  { value, onChange, onKeyDown, chip, onRemoveChip, placeholder, listId, activeId, expanded, label, t },
  ref
) {
  const ChipIcon = chip?.icon;
  return (
    <div className="palette-search command-palette-search">
      <Search size={16} className="palette-search-icon" aria-hidden="true" />
      {chip ? (
        <button
          type="button"
          className="palette-chip command-palette-filter-chip"
          aria-label={t('palette.chip.remove', { label: chip.label })}
          onMouseDown={(e) => e.preventDefault()}
          onClick={onRemoveChip}
        >
          {ChipIcon ? <ChipIcon size={12} aria-hidden="true" /> : null}
          <span>{chip.label}</span>
          <X size={11} strokeWidth={2.2} aria-hidden="true" />
        </button>
      ) : null}
      <input
        ref={ref}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value, e.timeStamp)}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        className="palette-input command-palette-input"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        role="combobox"
        aria-expanded={expanded ? 'true' : 'false'}
        aria-controls={listId}
        aria-activedescendant={activeId || undefined}
        aria-autocomplete="list"
        aria-label={label}
      />
    </div>
  );
});

export default PaletteInput;
